import { render, staticRenderFns } from "./dossier-detail-view.vue?vue&type=template&id=2ab46603&scoped=true"
import script from "./dossier-detail-view.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab46603",
  null
  
)

export default component.exports